import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/emergency`,
});

// ── Helper: auth header ──────────────────────
const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// ── Admin: fetch all emergencies (paginated + search) ──
export async function getAllEmergenciesByAdmin(payload) {
  try {
    const res = await API.post("/all", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ── Admin: resolve an emergency ──────────────
// payload: { resolvedBy, resolvedNote }
export async function resolveEmergencyByAdmin(id, payload = {}) {
  try {
    const res = await API.patch(`/${id}/resolve`, payload, {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ── Passenger: trigger SOS ───────────────────
// payload: { rideId, passengerId, passengerName, passengerMobile,
//            location: { lat, lng }, reason, reasonNote, message }
export async function triggerEmergencyByPassenger(payload) {
  try {
    const res = await API.post("/trigger", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}